import { GUI } from "dat.gui";
import { Mesh } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import model from "../../../../../assets/models/tema5/GLB_Caja Registradora_V2.glb";
import gsap from "gsap";

export class CashRegister extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);

	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
		});
	}

	onAnimationMovePosition(object, target = { x: 0, y: 0, z: 0 }, duration = 2, callBack = () => { }) {
		if (!object) {
			return
		}

		gsap.to(object.position,
			{
				duration,
				x: target.x,
				y: target.y,
				z: target.z,
				onComplete: () => {
					callBack();
				},
			})
	}

	onAnimationMoveRotation(object, target = { x: 0, y: 0, z: 0 }, duration = 2, callBack = () => { }) {
		if (!object) {
			return
		}

		gsap.to(object.rotation,
			{
				duration,
				x: target.x,
				y: target.y,
				z: target.z,
				onComplete: () => {
					callBack();
				},
			})
	}

	helpers(limit = 10) {
		const gui = new GUI();
		const folderMostrador = gui.addFolder("Caja");
		folderMostrador.add(this.scale, "x", -limit, limit).step(0.0001).name("Ancho");
		folderMostrador.add(this.scale, "y", -limit, limit).step(0.0001).name("Alto");

		folderMostrador.add(this.position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderMostrador.add(this.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderMostrador.add(this.position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folderMostrador.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderMostrador.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderMostrador.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderMostrador.add(this, "visible").name("Visible");
	}
}
